export default function focus(field: unknown): void {
  if (!field) {
    return;
  }
  setTimeout(() => {
    const f = field as HTMLElement;
    f.focus();
  }, 1);
}
